export default __webpack_public_path__ + "static/media/points.4f739e22.png";